$(document).ready(function(){
   console.log('ML');

   // Scrolled Items
   function handleScroll() {
      let $window = $(this);
      let scrollHeight = $window.scrollTop();
      let windowWidth = $(window).width();
      let $elements = $(".site-header");

      let $elementsNoClassBelow1200 = $(".menu-item a");

      $elements.toggleClass('scrolled', scrollHeight > $elements.first().height());

      if (windowWidth < 1200) {
         $elementsNoClassBelow1200.removeClass('scrolled');
      }
   }

   $(document).scroll(handleScroll);
   handleScroll();

   //  Show/hide sub-category
   $(".category__toggle").on("click", function () {
      const subCategory = $(this).parent().next(".sub-category");

      subCategory.stop(true, true).slideToggle(0, function () {

         const isVisible = subCategory.is(":visible");
         $(this).prev().find(".category__toggle").text(isVisible ? "−" : "+");
      });
   });

   // Show/hide filters
   const $toggleButton = $('.products-filters__toggle');
   const $filterItems = $('.products-filters__items');

   if ($toggleButton.length && $filterItems.length) {
      $toggleButton.on('click', function () {
         const isCollapsed = $filterItems.toggleClass('collapsed').hasClass('collapsed');
         $toggleButton.text(isCollapsed ? '+' : '−');
         $toggleButton.attr('aria-expanded', !isCollapsed);
      });
      const checkWindowSize = function() {
         if ($(window).width() > 850) {
            $filterItems.removeClass('collapsed');
            $toggleButton.attr('aria-expanded', true).text('−');
         } else {
            $filterItems.addClass('collapsed');
            $toggleButton.attr('aria-expanded', false).text('+');
         }
      }

      $(window).on('resize', checkWindowSize);
      checkWindowSize();
   }
});

// Woo
$(document).ready(function() {
   if ((document.body.classList.contains('page-id-63')) || (document.body.classList.contains('page-id-543'))) {
      const currentPath = window.location.pathname;
      const isEnglish = currentPath.includes('/en/');
      const basePath = isEnglish
          ? currentPath.replace('/en/', '/')
          : currentPath;

      const currentUrl = `${window.location.origin}${basePath}`;

      $('.products-output').html('<div class="loader"></div>');

      $.ajax({
         type: 'POST',
         url: `${window.location.origin}/wp-admin/admin-ajax.php`,
         dataType: 'json',
         data: {
            action: 'filter_projects',
            arrayTerm: []
         },
         success: function(res) {
            $('.loader').remove();

            $('.products-output').html(res.html);
            $('.product-counter__value').text(res.product_count);
         },
         error: function() {
            $('.loader').remove();
            alert('An error occurred while loading products.');
         }
      });
   }


   let arrayTerm = [];

   $('.product-filters__checkbox input').on('change', function () {
      const $checkbox = $(this);
      const termData = {
         term: $checkbox.data("term"),
         slug: $checkbox.data("slug")
      };

      if ($checkbox.is(':checked')) {
         arrayTerm.push(termData);
      } else {
         arrayTerm = arrayTerm.filter(item => item.term !== termData.term);
      }

      let categorySlug = null;

      $('.category__link').each(function() {
         if ($(this).hasClass('active')) {
            categorySlug = $(this).data('slug');
         }
      });

      console.log(categorySlug);

      // Wysłanie danych do backendu
      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'filter_projects',
            categorySlug: categorySlug,
            arrayTerm: arrayTerm
         },
         success: function (res) {
            $('.products-output').html(res.html);
            $('.product-counter__value').text(res.product_count);
         }
      });
   });

   $('#sort-options').on('change', function () {
      const sortOption = $(this).val();
      const categorySlug = $('.category__link.active').data('slug') || null;
      const arrayTerm = $('.product-filters__checkbox input:checked').map(function () {
         return {
            term: $(this).data('term'),
            slug: $(this).data('slug')
         };
      }).get();

      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'filter_projects',
            sort: sortOption,
            categorySlug: categorySlug,
            arrayTerm: arrayTerm
         },
         success: function (res) {
            $('.products-output').html(res.html);
            $('.product-counter__value').text(res.product_count);
         }
      });
   });

   function generateCategoryLinks() {
      $('.category__link, .sub-category__link').each(function() {
         let slug = $(this).data('slug');
         let term = $(this).data('term');
         let categoryLink = `https://shop.milleniumhost.pl/wyroby/?category_slug=${slug}&category_term=${term}`;
         $(this).attr('href', categoryLink);
      });
   }

   $('.category__link, .sub-category__link').on('click', function(e) {
      e.preventDefault();

      $('.category__link, .sub-category__link').removeClass('active');

      $(this).addClass('active');

      const slug = $(this).data('slug');
      const term = $(this).data('term');

      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'filter_projects',
            arrayTerm: [{ term: term, slug: slug }]
         },
         success: function(res) {
            $('.products-output').html(res.html); // Zaktualizuj HTML produktów
            $('.product-counter__value').text(res.product_count); // Ustaw licznik produktów
         }
      });

      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'get_category_content',
            slug: slug,
            term: term
         },
         success: function(response) {
            if (response.success) {
               $('.about-products__header').text(response.data.title);
               $('.about-products__description').html(response.data.description);
            }
         },
         error: function() {
            console.log('Błąd podczas pobierania danych kategorii');
         }
      });
   });

   generateCategoryLinks();

   const urlParams = new URLSearchParams(window.location.search);
   const categorySlug = urlParams.get('category_slug');
   const categoryTerm = urlParams.get('category_term');

   if (categorySlug && categoryTerm) {
      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'filter_projects',
            arrayTerm: [{ term: categoryTerm, slug: categorySlug }]
         },
         success: function(res) {
            $('.products-output').html(res.html);
            $('.product-counter__value').text(res.product_count);
         }
      });

      $.ajax({
         type: 'POST',
         url: 'https://shop.milleniumhost.pl/wp-admin/admin-ajax.php',
         dataType: 'json',
         data: {
            action: 'get_category_content',
            slug: categorySlug,
            term: categoryTerm
         },
         success: function(response) {
            if (response.success) {
               $('.about-products__header').text(response.data.title);
               $('.about-products__description').html(response.data.description);
            }
         },
         error: function() {
            console.log('Błąd podczas pobierania danych kategorii');
         }
      });
   }
});

